import styled from 'styled-components';

// A generic styled component that can be used instead of adding ref types to a component
export const IntersectObserver = styled.div`
  display: block;
  height: 0;
`;
